<template>
  <img class="tip animated bounce infinite" src="~images/tip.png" />
</template>

<script>
export default {
  name: "Tip",
};
</script>

<style lang="less" scoped>
.tip {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  width: 0.92rem;
  margin-left: -0.92/2rem;
}
</style>